module.exports = __webpack_public_path__ + "static/media/thumbnail-global-leaderboard@2x.4e81db8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/GymTvThumbnails/thumbnail-global-leaderboard@2x.png
// module id = 1085
// module chunks = 2